import React, {useEffect, useContext} from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../index";
import ProductItem from "./ProductItem";
import { getFavoriteProductsParent } from "../http/productAPI";
import { Container, Button } from 'react-bootstrap';
import { Check2All } from 'react-bootstrap-icons';
import { XCircle } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { useFavoriteProductsLoader } from "../hooks/useFavoriteProductsLoader";



const FavoriteProducts = observer(() => {
    const { user, product } = useContext(Context);      
    const navigate = useNavigate();
      
    const handleClose = () => console.log(0);
    
    useFavoriteProductsLoader();
     
 
          return (
            <>
            {product.products && product.products.length > 0 ? (
               product.products.map((product, index) => (
               <React.Fragment key={product.id}>
               <ProductItem 
                   productItem={product} 
                   handleClose={handleClose}                   
               />               
           </React.Fragment>
       ))) : (
             <Container className="mb-4 px-0">
        <div className="d-flex flex-column justify-content-center align-items-center text-center w-100 py-5">
          <XCircle size={80} className="text-danger mb-3" />
          <h4>Товары не найдены </h4>
          <h5> Попробуйте изменить парамертры поиска </h5>
          <div className="d-flex gap-3 flex-wrap justify-content-center pb-5" >
            <Button
                variant="outline-success"
                className="d-flex align-items-center rounded-4 custom-green-outline"
                onClick={() => navigate('/catalog')}
              >
                <Check2All className="me-2" />
                Вернуться в каталог
            </Button>
            </div>
        </div>
      </Container>
    )}
    </>
    );
    });
    
    export default FavoriteProducts;